<template lang="pug">
.new-config
  shForm(title="Nueva Configuración")
</template>

<script>
import shForm from '@/components/pages/config/Form'

export default {
  name: 'NewConfig',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-config
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/config/New.vue